import { apiUrls } from '../../../utils/constants/urls'
import { removeEmptyParameters } from '../../../utils/queryParameters'
import toast from '../../elem/Toast'

const getBidPackage = (authFetch, API_URL, bidPackageId, after) => {
    authFetch(
        `${API_URL}/${apiUrls.bidPackage}/${bidPackageId}`
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Bid Package: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const getBidPackageSchema = (authFetch, API_URL, after) => {
    authFetch(
        `${API_URL}/${apiUrls.schema}/bidPackage`
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Schema: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
            })
        })
}

const getBidPackageAutoCalc = (authFetch, API_URL, bidPackage, abortController, after) => {
    const queryParams = removeEmptyParameters(bidPackage)
    const POST = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify(queryParams),
        signal: abortController.signal
    }  
    authFetch(
        `${API_URL}/${apiUrls.autoCalc}/bidPackage`,
        POST
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            if (e.name !== 'AbortError') {
                toast({
                    level: 'error',
                    message:
                        'Schema: ' +
                        (e.message
                            ? e.message
                            : 'Unable to connect to the server. Please try again later.'),
                })
            }
        })
}

const createBidPackage = (authFetch, API_URL, bidPackage, onSuccess, onError ) => {
    const url = `${API_URL}/${apiUrls.bidPackage}/create`
    const POST = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify(bidPackage)
    }  
    authFetch(
        url, POST
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            toast({
                level: 'success',
                message: response.message,
                alert: true
            })
            onSuccess(response.createdId)
            
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Create Bid Package: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
                alert: true
            })
            onError(e)
        })
}

const updateBidPackage = (authFetch, API_URL, bidPackage, onSuccess, onError) => {
    const url = `${API_URL}/${apiUrls.bidPackage}` 
    const POST = {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers':
                'Access-Control-Allow-Origin, X-Requested-With, Content-Type, Accept',
        },
        body: JSON.stringify(bidPackage)
    }  
    authFetch(
        url, POST
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            toast({
                level: 'success',
                message: response.message,
                alert: true
            })
            onSuccess(response)
        })
        .catch((e) => {
            toast({
                level: 'error',
                message:
                    'Update Bid Package: ' +
                    (e.message
                        ? e.message
                        : 'Unable to connect to the server. Please try again later.'),
                    alert: true,
            })
            onError(e)
        })
}

export { getBidPackage, getBidPackageSchema, createBidPackage, updateBidPackage, getBidPackageAutoCalc }
